/*
 * Copyright 2023 The Android Open Source Project
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
package org.multipaz.documenttype

/**
 * Class that represents a combination of an integer value
 * and a name suitable for display
 *
 * @param value a integer value.
 * @param displayName a name suitable for display of the value.
 */
data class IntegerOption(
    val value: Int?,
    val displayName: String
) {
    /**
     * Show only the [displayName] in the toString function.
     */
    override fun toString(): String = displayName
}